import { Chip, Box } from "@mui/material";
import axios from "axios";
import moment from "moment";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { suggerimentoPrenotazione } from "../../../const/urlAction";
import "../../../index.css";
import DialogConfermaPrenotazioneSuggerimentoNew from "../Dialogs/DialogConfermaPrenotazioneSuggerimentoNew";
import handlerIconSuggerimenti from "../../../functions/stepper/suggerimenti/handlerIconSuggerimenti";

const urlBase = process.env.REACT_APP_URL;

export default function PannelloSuggerimentiPrenotazioneNew({ label = "", showSuggerimenti = true }) {
  const [elements, setElements] = useState([]);
  const [elementsSelected, setElementsSelected] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const userDate = useSelector((state) => state.userDate);
  const scrollRef = useRef(null);
  const { selectedDate, selectedStartTime, selectedEndTime } = useSelector(
    (state) => state.prenotazioneNew
  );
  

  const handleWheel = (e) => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft += e.deltaY;
    }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      setIsScrolled(scrollRef.current.scrollLeft > 0);
    }
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  useEffect(() => {
    let isMounted = true;
    if (showSuggerimenti && selectedDate && selectedStartTime && selectedEndTime) {
      (async () => {
        let body = {
          IdUtente: userDate.idUtente,
          OraInizioPrenotazione: moment(new Date(selectedStartTime)).format("HH:mm"),
          OraFinePrenotazione: moment(new Date(selectedEndTime)).format("HH:mm"),
          dataPrenotazione: moment(new Date(selectedDate)).format("YYYY-MM-DDTHH:mm:ss"),
          isPrenotazioneMultipla: false
        };
        const { action, method } = suggerimentoPrenotazione;
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: body,
          });
          if (response.data.ok && isMounted) {
            setElements(response.data.result || []);
          }
        } catch (error) {
          console.error("Error fetching suggestions:", error);
          setElements([]);
        }
      })();
    } else {
      setElements([]);
    }
    return () => { isMounted = false; };
  }, [selectedDate, selectedStartTime, selectedEndTime, showSuggerimenti, userDate.idUtente]);

  return (
    <Box 
      ref={scrollRef}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      onWheel={handleWheel}
      onScroll={handleScroll}
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        overflowX: 'auto', 
        pl: 1,
        flexWrap: 'nowrap', 
        width: '100%',
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        maskImage: isScrolled 
          ? 'linear-gradient(to right, transparent, black 5%, black 90%, transparent)' 
          : 'linear-gradient(to right, black, black 90%, transparent)',
        WebkitMaskImage: isScrolled 
          ? 'linear-gradient(to right, transparent, black 5%, black 90%, transparent)' 
          : 'linear-gradient(to right, black, black 90%, transparent)',
        '&::-webkit-scrollbar': { display: 'none' }, 
        msOverflowStyle: 'none', 
        scrollbarWidth: 'none',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
        {elements.length > 0 && elements.map((el, index) => {
          const icon = handlerIconSuggerimenti(el.idTipologiaStanza, false);
          const fullText = `${el.stanzaDenominazione} ${el.isSalaRiunione ? '' : `${el.posto}`}`;

          return (
            <Chip
              key={index}
              icon={icon}
              label={fullText}
              title={fullText}
              onClick={(e) => setElementsSelected({ elementoDaMostrare: el, e })}
              variant="outlined"
              sx={{ 
                  flexShrink: 0, 
                  width: '150px',
                  height: '36px',
                  backgroundColor: '#3e6bb4',
                  borderColor: '#3e6bb4',
                  color: 'white',
                  fontWeight: 600,
                  fontSize: '0.82rem',
                  '&:hover': {
                      backgroundColor: 'white',
                      borderColor: '#3e6bb4',
                      color: '#3e6bb4',
                      '& .MuiChip-icon': { color: '#3e6bb4' }
                  },
                  '& .MuiChip-icon': {
                      fontSize: '0.9rem',
                      color: 'rgba(255, 255, 255, 0.7)',
                      marginLeft: '8px'
                  },
                  '& .MuiChip-label': {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      display: 'block',
                      textAlign: 'center',
                      width: '100%',
                      lineHeight: '32px',
                      height: '100%',
                  }
              }}
            />
          );
        })}
        
        {/* Questo Box vuoto garantisce che ci sia spazio "vuoto" dopo l'ultima chip 
            per permettere al gradiente 'transparent' di vedersi correttamente */}
        <Box sx={{ minWidth: '40px', height: '10px', flexShrink: 0 }} />
      </Box>

      {elementsSelected && (
        <DialogConfermaPrenotazioneSuggerimentoNew
          elementsSelected={elementsSelected}
        />
      )}
    </Box>
  );
}